import { createSlice } from "@reduxjs/toolkit";

const verifyblogSlice = createSlice({
  name: "verifyblog",
  initialState: {
    isVerifyOpen: false,
  },
  reducers: {
    toogleVerify: (state) => {
      state.isVerifyOpen = !state.isVerifyOpen;
    },
  },
});

export const { toogleVerify } = verifyblogSlice.actions;
export default verifyblogSlice.reducer;